import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { User } from '@model/user/user';
import packageJson from '../../../../../package.json';
import { getUserLocal, LocalSettingsKey } from '@shared/types/local-settings';

@Injectable({
  providedIn: 'root'
})
export class AppHttpHeadersService {
  user: User;
  public version: string = packageJson.version;

  constructor() { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + this.getUserToken(),
    });
  }

  getAccessTokenHeaders(accessToken: string): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + accessToken,
    });
  }

  getV2AuthHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + this.getUserToken(),
      'Accept': 'application/x.yaanimail.v2+json'
    });
  }

  getV2RefreshTokenHeaders(refreshToken?: string): HttpHeaders {
    return new HttpHeaders({
      'Authorization': 'Bearer ' + (refreshToken || this.getUserRefreshToken()),
      'Accept': 'application/x.yaanimail.v2+json'
    });
  }


  getV2Headers(): HttpHeaders {
    return new HttpHeaders({
      'Accept': 'application/x.yaanimail.v2+json'
    });
  }

  getSessionHeaders(): HttpHeaders {
    return new HttpHeaders({
      'session-id': this.getSessionIdFromStorage(),
    });
  }

  getMsisdnSessionHeaders(session_id: string): HttpHeaders {
    return new HttpHeaders({
      'session-id': session_id,
      'Authorization': 'Bearer ' + this.getUserToken()
    });
  }

  getSessionIdFromStorage(): string {
    this.user = JSON.parse(localStorage.getItem(LocalSettingsKey.USER));
    return this.user.sessionId;
  }

  getUserToken(): string {
    return getUserLocal('token');
  }

  getUserRefreshToken(): string {
    return getUserLocal('refresh_token');
  }
}
